<div class="notification-bell">
  <!-- Bell button with unread badge -->
  <button
    type="button"
    class="notification-bell__btn"
    (click)="toggleDropdown()"
    [attr.aria-label]="'notifications.bell_label' | translate"
    [attr.aria-expanded]="isDropdownOpen()"
  >
    <tds-icon name="notifications" size="md"></tds-icon>
    @if (unreadCount() > 0) {
      <span class="notification-bell__badge" aria-hidden="true">
        {{ unreadCount() > 99 ? '99+' : unreadCount() }}
      </span>
    }
  </button>

  <!-- Dropdown panel -->
  @if (isDropdownOpen()) {
    <div class="notification-bell__dropdown" role="menu" aria-label="Notifications">
      <!-- Header -->
      <div class="notification-bell__dropdown-header">
        <span tds-typography variant="body-1" class="notification-bell__dropdown-title">
          {{ 'notifications.title' | translate }}
        </span>
        @if (unreadCount() > 0) {
          <button type="button" class="notification-bell__mark-all" (click)="markAllAsRead()">
            {{ 'notifications.mark_all_read' | translate }}
          </button>
        }
      </div>

      <!-- Notification list -->
      <div class="notification-bell__list">
        @if (notifications().length === 0) {
          <div class="notification-bell__empty">
            <tds-icon name="notifications" size="md" class="notification-bell__empty-icon"></tds-icon>
            <span tds-typography variant="body-2" class="notification-bell__empty-text">
              {{ 'notifications.empty' | translate }}
            </span>
          </div>
        } @else {
          @for (notification of notifications(); track notification.id) {
            <button
              type="button"
              class="notification-bell__item"
              [class.notification-bell__item--unread]="!notification.read_at"
              (click)="markAsRead(notification.id)"
              role="menuitem"
            >
              <!-- Unread indicator -->
              @if (!notification.read_at) {
                <span class="notification-bell__unread-dot" aria-hidden="true"></span>
              }

              <!-- Content -->
              <div class="notification-bell__item-content">
                <!-- Event description -->
                <span class="notification-bell__item-title">
                  @if (notification.data.contractor_name) {
                    {{ notification.data.contractor_name }}
                    @if (notification.data.igg) {
                      <span class="notification-bell__item-igg">({{ notification.data.igg }})</span>
                    }
                  } @else {
                    {{ resolveTitle(notification) }}
                  }
                </span>

                <!-- Outcome message -->
                @if (notification.data.message_key || notification.data.message || notification.data.outcome) {
                  <span class="notification-bell__item-outcome">
                    {{ resolveMessage(notification) }}
                  </span>
                }

                <!-- Date if applicable -->
                @if (notification.data.requested_end_date) {
                  <span class="notification-bell__item-date">
                    {{ 'notifications.new_end_date' | translate }}: {{ notification.data.requested_end_date }}
                  </span>
                }

                <!-- Timestamp -->
                <span class="notification-bell__item-timestamp">
                  {{ notification.created_at | appDate: 'datetime' }}
                </span>
              </div>
            </button>
          }
        }
      </div>
    </div>
  }
</div>
